// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__140io","title":"Images45_title__3b7xr","images":"Images45_images__3q1lS"};